import { Button } from '@efexteam/components';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Position } from '../types';
import DEFAULT_POSITION from './constants';
import RatesPopUp from './ratesPopUp';

const PromoterRates = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [position, setPosition] = useState<Position>(DEFAULT_POSITION);
  return (
    <Box>
      <Button
        appearance="secondary"
        size="large"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {t('prtActionButton')}
      </Button>
      <RatesPopUp
        isOpen={isOpen}
        updatePosition={setPosition}
        position={position}
        setIsOpen={setIsOpen}
      />
    </Box>
  );
};

export default PromoterRates;
